import { network } from '@root/utils'
import { handleReturn, QueryFunction } from '../root'

interface IYtjCompanySearchProps {
  searchTerm: string
}

export interface IYTJCompanySearchResult {
  business_id: string
  name?: string
  form: string
}

export interface IYTJAddressDetails {
  street?: string | null
  house_number?: string | null
  stair?: string | null
  apartment?: string | null
  po_box?: string | null
  postal_code?: string | null
  locality?: string | null
  country?: string | null
}

export interface IYTJCompanyDetails {
  postal_address?: IYTJAddressDetails | null
  visiting_address?: IYTJAddressDetails | null
  trade_name?: { name?: string | null } | null
  business_id_details?: { business_id?: string | null } | null
}

const addressRank = (address?: IYTJAddressDetails | null): number => {
  if (!address) return -1
  if (address.street || address.house_number) return 3
  if (address.po_box) return 2
  if (address.locality || address.postal_code) return 1
  return 0
}

export const pickYtjAddress = (
  details: IYTJCompanyDetails | null | undefined
): IYTJAddressDetails | null | undefined => {
  if (!details) return undefined
  const visitingRank = addressRank(details.visiting_address)
  const postalRank = addressRank(details.postal_address)
  if (visitingRank < 0 && postalRank < 0) {
    return details.visiting_address ?? details.postal_address
  }
  return visitingRank >= postalRank ? details.visiting_address : details.postal_address
}

export const formatYtjStreet = (address: IYTJAddressDetails | null | undefined): string => {
  const street = [address?.street, address?.house_number, address?.stair, address?.apartment]
    .filter(Boolean)
    .join(' ')
  if (street) return street
  return address?.po_box ? `PL ${address.po_box}` : ''
}

export const ytjCompanySearch: QueryFunction<
  IYtjCompanySearchProps,
  IYTJCompanySearchResult[]
> = async ({ searchTerm }) => {
  const url = `v1/integrations/ytj/search/`
  const { status, data } = await network.httpClient.request({
    url,
    method: 'GET',
    params: { search: searchTerm },
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}

interface IYtjCompanyDetailsProps {
  businessId: string
}

export const fetchYtjCompanyDetails: QueryFunction<
  IYtjCompanyDetailsProps,
  IYTJCompanyDetails
> = async ({ businessId }) => {
  const url = `v1/integrations/ytj/company_details/`
  const { status, data } = await network.httpClient.request({
    url,
    method: 'GET',
    params: { business_id: businessId },
    validateStatus: () => true
  })
  return handleReturn({ status, data })
}
